import React from 'react';
import { 
	SelectInput,
	ReferenceArrayInput,
	AutocompleteArrayInput,
	NumberInput
} from 'react-admin';
import { RangeFilter } from 'components/Fields';
import { DebouncedTextField } from 'components/Fields';
import FilterContainer from 'components/containers/Filter';

const OrganizationFilters = (props) => (
	<FilterContainer {...props} variant='standard' margin='normal'>
		<DebouncedTextField source='ic_name' label='Name' />
		<DebouncedTextField source='ic_creator_name' label='Registered By' />
		<SelectInput
			source='status'
			label='Status'
			choices={[
				{ id: 'not-claimed', name: 'Not Claimed' },
				{ id: 'inactive', name: 'Inactive' },
				{ id: 'active', name: 'Active' },
			]}
		/>
		<SelectInput
			source='size'
			label='Size'
			choices={[
				{ id: 'GrassrootsOrStartup', name: 'Grassroots / Startup' },
				{ id: 'MediumNationalOrRegionalFocus', name: 'Medium - National / Regional Focus' },
				{ id: 'MajorInternationalAndMajorFunding', name: 'Major - International / Major Funding' },
			]}
		/>		
		<ReferenceArrayInput
			label='Domains'
			source='$domains->id$'
			reference='domains'
			perPage={25}
			filterToQuery={(searchText) => ({
				q: searchText,
				_q_op: 'isw',
				_autocomplete: true
			})}
			sort={{ field: 'id', order: 'ASC' }}
		>
			<AutocompleteArrayInput
				matchSuggestion={(filterValue, suggestion) => true}
				optionText='name'
			/>
		</ReferenceArrayInput>
		<ReferenceArrayInput
			label='Tags'
			source='$tags->id$'
			reference='tags'
			perPage={25}
			filterToQuery={(searchText) => ({
				q: searchText,
				_q_op: 'isw',
				_autocomplete: true
			})}
			sort={{ field: 'id', order: 'ASC' }}
		>
			<AutocompleteArrayInput
				matchSuggestion={(filterValue, suggestion) => true}
				optionText='name'
			/>
		</ReferenceArrayInput>
		<DebouncedTextField source='ic_agenda' label='Agenda' />
		<DebouncedTextField source='ic_additional_target_audiences' label='Additional Target Audiences' />
		<DebouncedTextField source='ic_website_link' label='Website URL' />
		<RangeFilter source='collaborators_count' label='# Collaborators'>
			<NumberInput source='min_collaborators_count' label='# Collaborators (from)' variant='standard' />
			<NumberInput source='max_collaborators_count' label='# Collaborators (to)' variant='standard' />
		</RangeFilter>
	</FilterContainer>
);

export default OrganizationFilters;